import * as rooTypes from './mutations_type';

export const state = {
  isLoading: false,
};

export const getters = {
  isLoading: s => s.isLoading
};

export const actions = {
  onLoadingOpen({ commit }) {
    commit(rooTypes.loadingOpen);
  },
  onLoadingClose({ commit }) {
    commit(rooTypes.loadingClose);
  }
};

export const mutations = {
  [rooTypes.loadingOpen](s) {
    s.isLoading = true;
  },

  [rooTypes.loadingClose](s) {
    s.isLoading = false
  }
};
